import dayjs from 'dayjs'
import {FC} from 'react'
import en from 'react-date-object/locales/gregorian_en'
import DatePicker from 'react-multi-date-picker'
import {FormDateProps, FormText, FormTextProps, GButton} from 'src/app/components/Libs'

interface NewFormTextProps extends FormTextProps {}

const CustomInput: FC<NewFormTextProps> = ({
  onFocus,
  className,
  value,
  placeholder,
  error,
  touched,
  disabled,
}) => {
  return (
    <FormText
      onFocus={onFocus}
      value={value}
      appendInnerIcon='IconCalendar'
      clickAppendInnerIcon={onFocus as () => void}
      appendInnerClassname='text-neutral-500'
      readOnly
      placeholder={placeholder}
      error={error}
      touched={touched}
      className={className}
      disabled={disabled}
    />
  )
}

interface DateRangePicker2Props extends FormDateProps {
  startDate: string | undefined
  endDate: string | undefined
  setStartDate?: (date: string | undefined) => void
  setEndDate?: (date: string | undefined) => void
  onSubmitValue: (value: any) => void
  onCancelValue?: (value: any) => void
  onClose?: () => void
  submitDisabled?: boolean
}

function MyPlugin({
  position,
  DatePicker,
  startDate,
  endDate,
  format,
  onSubmitValue,
  onCancelValue,
  submitDisabled,
}: any) {
  return (
    <div className='flex items-center justify-between w-full px-6 py-4'>
      <div>
        {startDate && dayjs(startDate).format(format)}{' '}
        {endDate && `- ${dayjs(endDate).format(format)}`}
      </div>
      <div className='flex items-center gap-2'>
        <GButton
          variant='OUTLINED'
          onClick={() => {
            if (onCancelValue) onCancelValue()
            DatePicker.closeCalendar()
          }}
        >
          Batal
        </GButton>
        <GButton
          onClick={() => {
            if (onSubmitValue) onSubmitValue([startDate, endDate])
            setTimeout(() => DatePicker.closeCalendar(), 200)
          }}
          disabled={submitDisabled}
        >
          Terapkan
        </GButton>
      </div>
    </div>
  )
}

export const DateRangePicker2: FC<DateRangePicker2Props> = ({
  placeholder = 'Custom Date',
  error,
  touched,
  format = 'DD/MM/YYYY',
  showTimePicker = false,
  className,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  onSubmitValue,
  onCancelValue,
  disabled,
  onClose,
  submitDisabled,
  ...rest
}) => {
  const weekDays = ['Mi', 'Se', 'Se', 'Ra', 'Ka', 'Ju', 'Sa']

  return (
    <DatePicker
      portal
      containerStyle={{
        width: '100%',
      }}
      render={
        <CustomInput
          placeholder={placeholder}
          error={error}
          touched={touched}
          inputClassName={className}
          className={className}
          disabled={disabled}
        />
      }
      weekDays={weekDays}
      months={[
        'Januari',
        'Februari',
        'Maret',
        'April',
        'Mei',
        'Juni',
        'Juli',
        'Agustus',
        'September',
        'Oktober',
        'November',
        'Desember',
      ]}
      format={format}
      showOtherDays
      className='mr-8 border-none custom-calendar placeholder:text-danger'
      monthYearSeparator=' '
      locale={en}
      onOpenPickNewDate={false}
      numberOfMonths={2}
      disableMonthPicker
      disableYearPicker
      onClose={onClose}
      plugins={[
        <MyPlugin
          key={0}
          position='bottom'
          startDate={startDate}
          endDate={endDate}
          format={format}
          onSubmitValue={onSubmitValue}
          onCancelValue={onCancelValue}
          submitDisabled={submitDisabled}
        />,
      ]}
      dateSeparator={' - ' as any}
      {...rest}
    />
  )
}
